(function () {
	const searchModal = () => {
		// La modale nasce dentro la sezione header, che ha will-change/transform (sticky):
		// quel box fa da contenitore al position: fixed e la tiene incastrata nell'header.
		// Spostata sotto body si posiziona rispetto alla finestra.
		// Primo figlio di body: resta il primo .predictive-search del documento, come prima
		// (predictive-search.js ne misura l'altezza con querySelector). Se il theme editor
		// ricarica la sezione, la copia vecchia sotto body viene tolta.
		const modals = Array.from(document.querySelectorAll(".search-modal"));
		const fresh = modals.find((m) => m.parentElement !== document.body);
		if (fresh) {
			modals.filter((m) => m !== fresh && m.parentElement === document.body).forEach((m) => m.remove());
			document.body.insertBefore(fresh, document.body.firstChild);
		}
		$(".search-modal-trigger,.search-modal__overlay,.search__close").click(
			function (e) {
				e.preventDefault();
				searchToggle();
			}
		);
	};
	$(document).on("keyup", function (e) {
		if ($(".search-modal").hasClass("active") && e.key == "Escape") {
			searchToggle();
		}
	});
	function searchToggle() {
		$("#search-modal").toggleClass("active");
		if ($("#search-modal").hasClass("active")) {
			$("#search-modal").find(".search__input")[0].focus();
		} else {
			$(".search-modal-trigger").focus();
		}
		
		if ($('.search-modal').hasClass('active')) {
			$('body').addClass('overflow-hidden')
		} else {
			$('body').removeClass('overflow-hidden')
		}
	}
	document.addEventListener("shopify:section:load", searchModal);
	searchModal();
})();
